import script from "./RightSidebarTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./RightSidebarTitle.vue?vue&type=script&lang=ts&setup=true"

import "./RightSidebarTitle.vue?vue&type=style&index=0&id=78e447d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78e447d2"]])

export default __exports__